const getters = {
  actividades (state: any) {
    return state.datos
  }
}

export default getters
